$(document).ready(function() {
 
    // Handle click events on elements with the class "site-nav--has-dropdown"
    $("li.site-nav--has-dropdown").click(function() {
      const $dropdown = $(this).find(".site-nav__link--has-dropdown"); // Only select the first occurrence
    
      if ($dropdown.attr("aria-expanded") === "false") {
        // Close other dropdowns first
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Open the clicked dropdown
        $dropdown.attr("aria-expanded", "true");
        $(this).addClass("active");
        
        // Add your code to display the dropdown menu as needed here
      } else {
        // Close the clicked dropdown
        $dropdown.attr("aria-expanded", "false");
        $(this).removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });
});
  
    // Handle focus events for VoiceOver
    $(document).on('focusin', function(event) {
      // Check if the focus is outside of elements with class "site-nav--has-dropdown"
      if ($(event.target).closest(".site-nav--has-dropdown").length === 0) {
        // Close all dropdowns by setting their "aria-expanded" attribute to "false"
        $("li.site-nav--has-dropdown > .site-nav__link--has-dropdown").attr("aria-expanded", "false");
        $("li.site-nav--has-dropdown").removeClass("active");
        
        // Add your code to hide the dropdown menu as needed here
      }
    });













    $(document).ready(function() {
      $('.site-nav--has-dropdown>a').each(function() {
          var $a = $(this);
          var $button = $('<button></button>')
              .text($a.text())
              .addClass($a.attr('class'))
              .attr('aria-expanded', $a.attr('aria-expanded'))
              .attr('tabindex', $a.attr('tabindex'));
          $a.replaceWith($button);
      });
  });
  




 


// Close open desktop navigation dropdowns on Escape
$(document).on("keydown", function (e) {
    if (e.key !== "Escape") return;

    const $openDetails = $("details.site-nav__details[open]");

    if (!$openDetails.length) return;

    $openDetails.each(function () {
        this.open = false;

        $(this)
            .find("> summary")
            .attr("aria-expanded", "false")
            .trigger("focus");

        $(this)
            .closest(".site-nav--has-dropdown")
            .removeClass("active");
    });

    e.preventDefault();
});


 

  /** ===============================
   * Apply Here Button
   * =============================== */
  $('a.btn:contains("Apply Here")').each(function () {
    var $btn = $(this);
    var href = $btn.attr('href');
    $btn.attr(
      'aria-label',
      'Apply here at ' + href.replace(/^https?:\/\//, '') + ', this link will open in a new tab'
    );
    $btn.attr('target', '_blank');
    $btn.attr('rel', 'noopener');
  });

  /** ===============================
   * Slideshow Hero Links
   * =============================== */
  $('.hero__slide-link').each(function () {
    var $link = $(this);
    var aria = $link.attr('aria-label');

    if (!aria) {
      var $img = $link.find('img[alt]');
      if ($img.length > 0) {
        var altText = $img.attr('alt').trim();
        if (altText) {
          $link.attr(
            'aria-label',
            altText + ', this link will open in a new tab'
          );
        }
      }
    } else {
      if (aria.indexOf('this link will open in a new tab') === -1) {
        $link.attr(
          'aria-label',
          aria.trim() + ', this link will open in a new tab'
        );
      }
    }

    $link.attr('target', '_blank');
    $link.attr('rel', 'noopener');
  });


 // URL → Accessible Label mapping
jQuery(document).ready(function ($) {
  var urlLabels = {
    "https://www.shopify.com/legal/privacy": "Shopify Privacy Policy",
    "https://www.shopify.com/legal/cookies": "Shopify Cookies Policy here",
    "https://policies.google.com/privacy?hl=en": "Google Privacy Policy",
    "https://tools.google.com/dlpage/gaoptout": "Google Analytics Opt-Out Tool",
    "http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work": "How Online Advertising Works - NAI",
    "https://www.facebook.com/settings/?tab=ads": "Facebook Ads Settings",
    "https://www.google.com/settings/ads/anonymous": "Google Ads Settings (Anonymous)",
    "https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads": "Microsoft Advertising Personalized Ads Policy",
    "http://optout.aboutads.info/": "AboutAds Opt-Out"
  };

  // Loop through all <a> links
   $('a[href]').each(function () {
     var $link = $(this);
     var href = $link.attr('href').trim();

     // Check if link matches in mapping
     if (urlLabels[href]) {
       var ariaText = urlLabels[href] + ", this link will open in a new tab";

       $link.attr('aria-label', ariaText);
       $link.attr('target', '_blank');
       $link.attr('rel', 'noopener');
     }
   });
 });
//  Apply aria-labels to phone and email links
$(document).ready(function () {
  $('a[href^="tel:"]').each(function () {
    var phone = $(this).text().trim();

    $(this).attr(
      'aria-label',
      'Phone: ' + phone
    );

    $(this).removeAttr('target');
  });
});
// complex image toggle
 
      /*
      $button.text(
        isExpanded
          ? "image description collapsed"
          : "image description expanded"
      );
      */

//     });

//   });

// });
//  end
// apply aria-labels to email links


// $('a').each(function () {
//   // Check if the link is external
//   if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.oakforless.com') {
//     // Create a span element with warning text
//     var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
//     // Set attributes for accessibility
//     $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
//     // Append the warning span inside the link
//     $(this).append(warningSpan);
//   }
// });

 
// // Email and phone number labels
// // jQuery(document).ready(function ($) {
// //   function handleContactLinks() {
// //     $('a[href^="mailto:"], a[href^="tel:"]').each(function () {
// //       var $link = $(this);
// //       var href = $link.attr('href');
      
// //       // Get the full visible text of the link
// //       var linkText = $.trim($link.text());

// //       if (href.indexOf('mailto:') === 0) {
// //         $link.attr('aria-label', 'Email Address: ' + linkText);
// //       } else if (href.indexOf('tel:') === 0) {
// //         $link.attr('aria-label', 'Phone number: ' + linkText);
// //       }

// //       // Always add/override target="_blank"
// //       $link.attr('target', '_blank');
// //     });
// //   }

// //   handleContactLinks();
// // });


// // remove empty link collectiion 
// // $(document).ready(function () {
// //   $(".grid-item__content a").each(function () {
// //     if ($.trim($(this).html()) === "") {
// //       $(this).remove();
// //     }
// //   });
// // });
// $(document).ready(function () {
//   // Function: remove empty <a>
//   function removeEmptyLinks(context) {
//     $(context).find(".grid-item__content a").each(function () {
//       if ($.trim($(this).html()) === "") {
//         $(this).remove();
//       }
//     });
//   }

//   // Run once on page load
//   removeEmptyLinks(document);

//   // MutationObserver
//   const observer = new MutationObserver(function (mutationsList) {
//     mutationsList.forEach(function (mutation) {
//       // Check added nodes
//       mutation.addedNodes.forEach(function (node) {
//         if (node.nodeType === 1) { // element node
//           if ($(node).is("a") && $.trim($(node).html()) === "") {
//             $(node).remove();
//           } else {
//             removeEmptyLinks(node); // scan inside
//           }
//         }
//       });
//     });
//   });

//   // Observe everything
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true,
//     characterData: true,
//     attributes: true
//   });
// });



// // variant clickable 
// jQuery(document).ready(function ($) {
//   $(".color-swatch").on("click", function () {
//     var url = $(this).data("url");
//     if (url) {
//       window.location.href = url;
//     }
//   });
//   $(".color-swatch").on("keydown", function (e) {
//     if (e.key === "Enter" || e.key === " ") {
//       e.preventDefault();
//       var url = $(this).data("url");
//       if (url) {
//         window.location.href = url;
//       }
//     }
//   });
// });

// // Accessibility update aria-selected and aria-label on grid view toggle buttons
// jQuery(document).ready(function ($) {
//   var $buttons = $(".grid-view-btn");

//   function updateAria() {
//     $buttons.each(function () {
//       var $btn = $(this);
//       var label = $btn.attr("title") || $btn.text().trim(); // "Large", "Small", etc.

//       if ($btn.hasClass("is-active")) {
//         $btn.attr("aria-selected", "true");
//         $btn.attr("aria-label", "Selected, switch to " + label + " product images");
//       } else {
//         $btn.attr("aria-selected", "false");
//         $btn.attr("aria-label", "Switch to " + label + " product images");
//       }
//     });
//   }

//   updateAria();

//   $buttons.on("click", function () {
//     $buttons.removeClass("is-active");
//     $(this).addClass("is-active");
//     updateAria();
//   });
// });


// // update label product images gallery
// jQuery(document).ready(function ($) {
//   const $slides = $('.product-main-slide');
//   const $thumbs = $('.product__thumb-item a');
//   const totalSlides = $slides.length;

//   function updateLabels() {
//     $slides.each(function (i) {
//       const $slide = $(this);
//       const $img = $slide.find('img');
//       const altText = $img.attr('alt') || 'Product image';
//       const index = i + 1;

//       if ($slide.hasClass('is-selected')) {
//         // Active main slide
//         $img.attr('aria-label', `Image ${index} of ${totalSlides} — ${altText}`);
//         $img.attr('role', 'img');
//         $img.attr('tabindex', '0');
//       } else {
//         $img.removeAttr('aria-label tabindex');
//       }

//       // Update thumbnail aria-label as well
//       const $thumb = $thumbs.eq(i);
//       if ($thumb.length) {
//         if ($slide.hasClass('is-selected')) {
//           $thumb.attr('aria-label', `Selected image ${index} of ${totalSlides} — ${altText}`);
//           $thumb.attr('aria-current', 'true');
//         } else {
//           $thumb.attr('aria-label', `Image ${index} of ${totalSlides} — ${altText}`);
//           $thumb.removeAttr('aria-current');
//         }
//       }
//     });
//   }

//   // Run initially
//   updateLabels();

//   // Observe slide changes
//   const observer = new MutationObserver(() => {
//     updateLabels();
//   });

//   $slides.each(function () {
//     observer.observe(this, { attributes: true, attributeFilter: ['class'] });
//   });
// });


// $(document).ready(function () {
//   $('.mobile-nav-trigger').on('click', function () {
//     // Slight delay to let the nav become visible
//     setTimeout(function () {
//       const $navWrapper = $('#MobileNav .slide-nav__wrapper');

//       if ($navWrapper.length && $('#MobileNav').hasClass('is-active')) {
//         $navWrapper.focus(); // ✅ Focus inner wrapper, not #MobileNav
//       }
//     }, 100);
//   });
// });


// // for mobile menu 
// jQuery(document).ready(function ($) {
//   let lastTriggerBtn = null;

  
//   $(document).on("click", ".js-toggle-submenu", function () {
//     const $btn = $(this);
//     const hiddenText = $btn.find(".skip-link.visually-hidden").text().trim();

   
//     if (hiddenText.startsWith("Open")) {
     
//       const target = $btn.data("target");
//       const $submenu = $(`[data-parent="${target}"]`);

      
//       lastTriggerBtn = this;

     
//       const $exitBtn = $submenu.find(".skip-link.visually-hidden")
//         .filter(function () {
//           return $(this).text().trim().startsWith("Exit");
//         })
//         .closest("button");

     
//       if ($exitBtn.length) {
//         setTimeout(() => $exitBtn.trigger("focus"), 50);
//       }
//     }

   
//     if (hiddenText.startsWith("Exit")) {
//       if (lastTriggerBtn) {
//         setTimeout(() => $(lastTriggerBtn).trigger("focus"), 150);
//       }
//     }
//   });
// });





//  $(document).ready(function () {
//     const $menu = $('#MobileNav');
//     const $menuBtn = $('.mobile-nav-trigger');
//     $('.skip-link[aria-label="Close mobile navigation menu"]').on('click', function () {
//       $menu.removeClass('is-active');
//       $menuBtn.removeClass('is-active'); 
//       $menu.attr('aria-hidden', 'true');

//       $menuBtn.focus();
//     });
//   });


// // add label to specific product image links
//   $(document).ready(function(){
//   $('[data-product-handle="od-traditional-oak-bookcase-24-w-choose-finish-choose-height"]')
//     .find('.grid-product__image-wrap a')
//     .each(function(){
//       var titleText = $(this).closest('.grid-item__content')
//                              .find('.grid-product__title')
//                              .text()
//                              .trim();
//       $(this).attr('aria-label', 'View image of ' + titleText);
//     });
// });


// // excape key for details menu close
// $(document).on("keydown", function (e) {
//   if (e.key === "Escape") {
//     let $openDropdown = $("details[open]"); 
//     if ($openDropdown.length) {
//       let $summary = $openDropdown.find("summary").first(); 
//       $openDropdown.removeAttr("open"); 
//       $summary.attr("aria-expanded", "false"); 
//       $summary.focus(); 
//       e.preventDefault();
//     }
//   }
// });
// // update aria-expanded on details toggle
// $(document).on("toggle", "details", function () {
//   let $summary = $(this).find("summary").first();
//   if (this.open) {
//     $summary.attr("aria-expanded", "true");
//   } else {
//     $summary.attr("aria-expanded", "false");
//   }
// });
